module.exports = __webpack_public_path__ + "static/media/loading.9ecd0a89.gif";